// alt initialization
const Alt = require('alt');
const alt = new Alt();

module.exports = alt;
